import type { IntakeAnswer } from "@/types/clinician";

/** The existing clinician answer rows, shared by legacy and versioned intakes. */
export function IntakeAnswerTable({
  answers,
  highlightSafety = false,
}: {
  answers: IntakeAnswer[];
  highlightSafety?: boolean;
}) {
  return (
    <div className="border border-line-subtle divide-y divide-line-subtle max-h-[38rem] overflow-y-auto">
      {answers.map((answer, index) => (
        <div
          key={`${answer.question}-${index}`}
          className={`p-9 grid md:grid-cols-[minmax(14rem,0.8fr)_minmax(0,1.2fr)] gap-5 md:gap-10 ${highlightSafety && answer.importance === "safety" ? "bg-danger-wash" : ""}`}
        >
          <span className="type-label-xs text-ink-muted">
            {answer.question}
          </span>
          <span className="type-body-sm font-medium break-words whitespace-pre-wrap">
            {answer.answer}
          </span>
        </div>
      ))}
    </div>
  );
}
